<template>
  <div>
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FF6907" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center class="rm-list-container pa-6">
      <v-flex xs12>
        <!-- ══ FILTERS CONTAINER ══ -->
        <div class="filter-card mb-6">
          <v-row align="center" class="ma-0">
            <v-col cols="12" sm="4" md="3" class="py-2 px-3">
              <span class="filter-label">Search Keyword</span>
              <v-text-field
                outlined
                hide-details
                dense
                placeholder="Type to search"
                v-model="keyword"
                color="#14532D"
                class="custom-input"
              />
            </v-col>
            
            <v-col cols="12" sm="4" md="3" class="py-2 px-3">
              <span class="filter-label">District</span>
              <v-select
                outlined
                hide-details
                dense
                placeholder="All Districts"
                :items="districts"
                v-model="district"
                color="#14532D"
                class="custom-select"
              />
            </v-col>

            <v-col cols="12" sm="4" md="2" class="py-2 px-3 d-flex align-end justify-sm-end" v-if="userlist && userlist.length > 0">
              <v-btn
                color="#10B981"
                class="export-btn w-full mt-5"
                target="_blank"
                @click="getExcel()"
                block
                depressed
              >
                <v-icon left size="16">mdi-microsoft-excel</v-icon>
                Export
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <!-- ══ TABLE CONTAINER ══ -->
        <v-layout wrap justify-start v-if="userlist && userlist.length > 0">
          <v-flex xs12>
            <v-card class="custom-table-card elevation-0">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Name</th>
                      <th class="text-left">Phone</th>
                      <th class="text-left">Email</th>
                      <th class="text-left">District</th>
                      <th class="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in userlist"
                      :key="index"
                      class="clickable-row"
                      @click="openviewdetails(item)"
                    >
                      <td class="font-weight-bold" style="color: #1E293B;">
                        <span v-if="item && item.user && item.user.name">{{ item.user.name }}</span>
                        <span v-else class="text-muted">-</span>
                      </td>
                      <td>
                        <span v-if="item && item.user && item.user.phone">{{ item.user.phone }}</span>
                        <span v-else class="text-muted">-</span>
                      </td>
                      <td>
                        <span v-if="item && item.user && item.user.email">{{ item.user.email }}</span>
                        <span v-else class="text-muted">-</span>
                      </td>
                      <td>
                        <v-chip small color="rgba(20,83,45,0.08)" text-color="#14532D" class="font-weight-medium">
                          {{ (item && item.district) ? item.district : '-' }}
                        </v-chip>
                      </td>
                      <td class="text-center" @click.stop>
                        <div class="d-flex align-center justify-center action-group">
                          <!-- Edit Details -->
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <button
                                class="action-btn action-btn--edit"
                                v-bind="attrs"
                                v-on="on"
                                @click="openeditdetails(item)"
                              >
                                <v-icon size="16">mdi-pencil</v-icon>
                              </button>
                            </template>
                            <span>Edit Rescuer</span>
                          </v-tooltip>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 pb-4 v-if="userlist && userlist.length > 0">
        <v-layout wrap justify-center class="mt-6">
          <v-flex xs10>
            <v-pagination
              v-model="currentPage"
              :length="Pagelength"
              circle
              color="#14532D"
              small
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 v-else>
        <div class="empty-state py-12 text-center">
          <v-icon size="64" color="#CBD5E1" class="mb-4">mdi-account-plus-outline</v-icon>
          <h3 class="text-h6 font-weight-bold grey--text text--darken-2">No New Requests</h3>
          <p class="text-body-2 grey--text text--darken-1">There are no pending rescuer requests matching your filters.</p>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>
    <script>
import axios from "axios";
export default {
  data() {
    const pageKey = this.$route.name || 'defaultPage';
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      count: 20,
      keyword: "",
      pageKey,
      currentPage: parseInt(localStorage.getItem(`${pageKey}_currentPage`)) || 1,
      Pagelength: 0,
      userlist: [],
      districts: [
        "All",
        "Palakkad",
        "Alappuzha",
        "Malappuram",
        "Kannur",
        "Wayanad",
        "Kozhikode",
        "Thrissur",
        "Thiruvananthapuram",
        "Kottayam",
        "Idukki",
        "Ernakulam",
        "Kollam",
        "Pathanamthitta",
        "Kasaragod",
      ],
      district:"",
    };
  },
  beforeMount() {
    this.getData();
  },
  watch: {
    currentPage(newVal) {
      localStorage.setItem(`${this.pageKey}_currentPage`, newVal);
      this.getData();
    },
    count() {
      this.getData();
    },
    keyword() {
      this.getData();
    },
    district(){
      this.getData();
    }
  },
  methods: {
    openviewdetails(item) {
      this.$router.push({
        path: "/newrescuerslistview",
        query: {
          id: item._id,
        },
      });
    },
    openeditdetails(item) {
      this.$router.push({
        path: "/newrescuerslistedit",
        query: {
          id: item.user._id,
        },
      });
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/rescuer/pending",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.count,
          page: this.currentPage,
          keyword: this.keyword,
          district:this.district
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.userlist = response.data.data;
              this.Pagelength = response.data.pages;
              // this.msg = response.data.msg;
              // this.showSnackBar = true;
              this.appLoading = false;
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          (this.ServerError = true), console.log(err);
        });
    },
    handlesubmit() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/snake/",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          name: this.commonname,
          scientificName: this.scientificname,
          states: this.state,
          rname: this.reginonalname,
          distribution: this.distribution,
          characteristics: this.scalation,
          description: this.description,
          venomType: this.venomtype,
          family: this.family,
          occurence: this.occurence,
          wlpa: this.wlpa,
          iucn: this.iucn,
          shortdes: this.shortdescription,
          othernames: this.othername,
          genus: this.genus,
          experts: this.experts,
        },
      })
        .then((response) => {
          if (response.data.status == true) {
            {
              this.msg = response.data.msg;
              this.showSnackBar = true;
              this.appLoading = false;
              this.commonname = "";
              this.scientificname = "";
              this.state = "";
              this.reginonalname = "";
              this.distribution = "";
              this.scalation = "";
              this.description = "";
              this.venomtype = "";
              this.family = "";
              this.occurence = "";
              this.wlpa = "";
              this.iucn = "";
              this.shortdescription = "";
              this.othername = "";
              this.genus = "";
              this.experts = "";
            }
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.appLoading = false;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          (this.ServerError = true), console.log(err);
        });
    },
    getExcel() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/rescuer/pending/download/excel",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        responseType: "blob",
        params: {
          keyword: this.keyword,
          district:this.district,
        },
      })
        .then((response) => {
          this.appLoading = false;
          const url = URL.createObjectURL(
            new Blob([response.data], {
              type: "application/vnd.ms-excel",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "NewRescuerList.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
/* ── Filter Card ── */
.filter-card {
  background: #FFFFFF;
  border-radius: 12px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.02);
  padding: 12px 6px;
}
.filter-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748B;
  margin-bottom: 6px;
  padding-left: 2px;
}

/* ── Custom Inputs ── */
.custom-select ::v-deep .v-input__control > .v-input__slot,
.custom-input ::v-deep .v-input__control > .v-input__slot {
  background: #F8FAFC !important;
  border-color: #E2E8F0 !important;
  border-radius: 8px !important;
  transition: all 0.2s ease;
}
.custom-select ::v-deep .v-input__control > .v-input__slot:hover,
.custom-input ::v-deep .v-input__control > .v-input__slot:hover {
  border-color: #CBD5E1 !important;
  background: #F1F5F9 !important;
}

/* ── Export Button ── */
.export-btn {
  background-color: #10B981 !important;
  color: #FFFFFF !important;
  font-family: 'Inter', sans-serif !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.02em !important;
  border-radius: 8px !important;
  height: 40px !important;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.18) !important;
  transition: all 0.2s ease !important;
}
.export-btn:hover {
  background-color: #059669 !important;
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.25) !important;
}

/* ── Table Card ── */
.custom-table-card {
  border-radius: 12px !important;
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.08) !important;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.03) !important;
  background: #FFFFFF;
}

/* Table layout styling */
.custom-table-card ::v-deep table {
  border-collapse: collapse;
  width: 100%;
}
.custom-table-card ::v-deep thead {
  background-color: #F8FAFC;
}
.custom-table-card ::v-deep th {
  height: 48px !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  letter-spacing: 0.06em !important;
  color: #64748B !important;
  text-transform: uppercase !important;
  border-bottom: 2px solid #F1F5F9 !important;
  padding: 0 16px !important;
}
.custom-table-card ::v-deep td {
  height: 58px !important;
  font-size: 13px !important;
  color: #334155 !important;
  border-bottom: 1px solid #F1F5F9 !important;
  padding: 0 16px !important;
}

/* ── Clickable Rows ── */
.clickable-row {
  cursor: pointer;
  transition: background-color 0.18s ease;
}
.clickable-row:hover {
  background-color: #F3F7F4 !important;
}
.clickable-row:active {
  background-color: #EBF2ED !important;
}
.text-muted {
  color: #94A3B8;
}

/* ── Action buttons ── */
.action-group {
  gap: 8px;
}
.action-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  outline: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.action-btn:hover {
  transform: scale(1.08);
}
.action-btn--edit {
  background: rgba(20, 83, 45, 0.06);
  color: #16A34A !important;
}
.action-btn--edit:hover {
  background: rgba(20, 83, 45, 0.12);
  color: #14532D !important;
}

/* ── Empty State ── */
.empty-state {
  background: #FFFFFF;
  border-radius: 12px;
  border: 1px dashed #E2E8F0;
}
</style>